import { PageTitle } from "@/components/molecules";
import {
  RegisterUserFormBizsol,
  RegisterUserFormBizsolValues,
} from "@/components/organisms";
import { MainTemplate } from "@/components/templates";
import {
  RegisterCompanyUserMutation,
  useRegisterCompanyUserMutation,
} from "@/generated/graphql";
import { useRouter } from "next/router";
import { useForm, FormProvider } from "react-hook-form";
import { useSnackBar } from "@moneyforward/mfx_biz_react_components";
import useRollbarUtil from "../hooks/useRollbarUtil";

export const RegisterUserBizsolPage = () => {
  const { getNotifyErrorHandlerForGraphQL } = useRollbarUtil();
  const router = useRouter();

  const methods = useForm<RegisterUserFormBizsolValues>({
    reValidateMode: "onBlur",
    defaultValues: {
      username: "",
      password: "",
      firstName: "",
      firstNameKana: "",
      middleName: "",
      middleNameKana: "",
      lastName: "",
      lastNameKana: "",
    },
  });

  const { notify } = useSnackBar();

  const [registerCompanyUserMutation] = useRegisterCompanyUserMutation({
    onCompleted: (data: RegisterCompanyUserMutation) => {
      if (data.registerCompanyUser.user) {
        notify("作成が完了しました");
        router.push("/manage-users");
      }
    },
    onError: getNotifyErrorHandlerForGraphQL(
      "Failed to register company user",
      "作成に失敗しました"
    ),
  });

  const handleSubmit = async (formValues: RegisterUserFormBizsolValues) => {
    var input = Object.assign({}, formValues);
    await registerCompanyUserMutation({
      variables: { input },
    });
  };

  return (
    <MainTemplate title={`利用者の新規作成`}>
      <PageTitle
        mainTitle={`利用者の新規作成`}
        subTitle={
          <>
            利用者の登録後は設定したユーザーID・仮パスワードで7日以内にログインが必要です。
            <br />
            ログイン期限を過ぎた場合は、利用者の編集画面からパスワードを再設定してください。
          </>
        }
      />
      <FormProvider {...methods}>
        <RegisterUserFormBizsol onSubmit={handleSubmit} />
      </FormProvider>
    </MainTemplate>
  );
};
